import {
  Component,
  Input,
  SimpleChanges,
  OnChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'mj-textarea',
  templateUrl: './mj-textarea.component.html',
  styleUrls: ['./mj-textarea.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MjTextareaComponent implements OnChanges {
  @Input() disabled: boolean;
  @Input() placeholder: string = '';
  @Input() error: any;
  @Input() maxLength: number = -1;
  @Input() formControlName: string = '';
  @Input() rows: number = 1;
  @Input() errorMsg: any;
  @Input() hint: string = '';
  @Input() required: boolean = false;
  @Input() type: string = 'string';
  @Input() minRows: number = 4;
  @Input() maxRows: number = 10;
  @Input() onlyGrow: boolean = false;
  @Input() useImportant: boolean = false;

  constructor(public _translate: TranslateService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes && !this.errorMsg) {
      this._translate.get('generic_field_required').subscribe(error_string => {
        this.errorMsg = error_string;
      });
    }
  }
}
